// extracted by mini-css-extract-plugin
export default {"inputContent":"myUploadedCV_inputContent__-wPXl","fileName":"myUploadedCV_fileName__fO9OA","uploadButton":"myUploadedCV_uploadButton__ADlmJ"};